export async function getToken() {

const token = localStorage.getItem("jwt");

if(!token){
   throw new Error("User not logged in");
}

return token;

}